import React from "react";
import AppToolbar from "./AppToolbar";
import RegistrationValidateEmailContainer from "../containers/RegistrationValidateEmailContainer";
import { Route, Switch } from "react-router-dom";
import SelfRegistrationContainer from "../containers/SelfRegistrationContainer";
import NotFound from "./NotFound";
import ReactGA from "react-ga";

//Dev
//ReactGA.initialize("UA-156367011-1");

//live
ReactGA.initialize("UA-156763812-1");
/*if (process.env.NODE_ENV !== "development") {
  const gaTrackingCode = process.env.REACT_APP_GA_TRACKCODE_ENROLLME;
  ReactGA.initialize(gaTrackingCode);
}*/

const App = () => (
  <div>
    <AppToolbar />

    <div className="mdc-toolbar-fixed-adjust">
      <Switch>
        <Route path="/" exact component={RegistrationValidateEmailContainer} />
        <Route
          path="/selfReg"
          exact
          render={props => <SelfRegistrationContainer {...props} />}
        />
        <Route component={NotFound} />
      </Switch>
    </div>
  </div>
);

export default App;
